export default __webpack_public_path__ + "static/media/coeur.494d3b37.png";